/* eslint-disable */
import session from './session';
import Braze from './braze';
import { world } from '../languages';
import usercentrics, { USERCENTRICS_SERVICES } from '../services/usercentrics';

const externalScriptsManager = {
    load(cookieServices) {
        const needsLoadGTM = usercentrics.isServiceAccepted(cookieServices, USERCENTRICS_SERVICES.GTM);
        const needsLoadGA = usercentrics.isServiceAccepted(cookieServices, USERCENTRICS_SERVICES.GA);
        const needsLoadFB = usercentrics.isServiceAccepted(cookieServices, USERCENTRICS_SERVICES.FACEBOOK);
        // const needsLoadPinterest = usercentrics.isServiceAccepted(cookieServices, USERCENTRICS_SERVICES.PINTEREST);
        const needsLoadBraze = usercentrics.isServiceAccepted(cookieServices, USERCENTRICS_SERVICES.BRAZE);

        if (needsLoadGTM) {
            this.initTagManager();
        }

        if (needsLoadGA) {
            this.initEhnancedEcommercePlugin();
        }

        if (needsLoadFB) {
            this.initFBConfig();
        }

        // if (needsLoadPinterest) {
        //     this.initPinterestTracker();
        // }

        if (needsLoadBraze) {
            this.initBraze();
        }
    },

    initTagManager: () => {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? `&l=${l}` : '';

            j.async = true;
            j.src = `//gtm.eduki.com/gtm.js?id=${i}${dl}`;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-MPS2TC');
    },

    facebookSDK: {
        inited: false,
        init() {
            if (!this.inited) {
                ((d, s, id) => {
                    const fjs = d.getElementsByTagName(s)[0];
                    const js = d.createElement(s);

                    if (d.getElementById(id)) {
                        return;
                    }

                    js.id = id;
                    js.src = 'https://connect.facebook.net/de_DE/sdk.js';
                    js.async = true;
                    js.defer = true;
                    fjs.parentNode.insertBefore(js, fjs);
                })(document, 'script', 'facebook-jssdk');

                this.inited = true;
            }
        }
    },

    appleLogin: {
        init() {
            if (window.AppleID?.auth) {
                return Promise.resolve();
            }

            return new Promise((resolve) => {
                const script = document.createElement('script');
                const localization = {
                    de: 'de_DE',
                    es: 'es_ES',
                    fr: 'fr_FR',
                    it: 'it_IT',
                    gr: 'en_US'
                };

                script.onload = () => {
                    window.AppleID.auth.init({
                        clientId: 'com.eduki.website.login', // This is the service ID we created.
                        scope: 'name email', // To tell apple we want the user name and emails fields in the response it sends us.
                        redirectURI: window.location.origin, // As registered along with our service ID
                        state: 'origin:web', // Any string of your choice that you may use for some logic. It's optional and you may omit it.
                        usePopup: true // Important if we want to capture the data apple sends on the client side.
                    });

                    resolve();
                };

                script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${localization[world]}/appleid.auth.js`;
                document.getElementsByTagName('head')[0].appendChild(script);
            });
        }
    },
    googleResponse: false,
    googleLogin: {
        init(onResponse) {
            if (this.googleResponse) {
                setTimeout(() => {
                    onResponse(this.googleResponse);
                }, 300);
                return Promise.resolve();
            }

            return new Promise((resolve) => {
                const script = document.createElement('script');

                // const onResponse = async ({ credential }) => {
                //     resolve(credential)
                // }
                script.onload = () => {
                    window.google.accounts.id.initialize({
                        ux_mode: "popup",
                        client_id: process.env.NODE_ENV !== 'production' ? '863862334691-0iit0nmabqvis5h4bp551r94228vmddq.apps.googleusercontent.com': '114721499725-jm8s26it1t059ea1piur0o60qhd4jaa7.apps.googleusercontent.com',
                        callback: (params) => { this.googleResponse = params; onResponse?.(params)},
                    });
                    resolve()
                };

                script.src = `https://accounts.google.com/gsi/client`;
                script.async = true;
                script.defer = true;
                document.getElementsByTagName('head')[0].appendChild(script);
            });
        }
    },

    fbShare(url) {
        const FBModal = (url = window.location.href) => {
            window.FB.ui(
                {
                    method: 'share',
                    mobile_iframe: true,
                    href: url
                },
                () => {}
            );
        };

        if (window.FB) {
            FBModal(url);
        } else {
            this.facebookSDK.init();

            const interval = setInterval(() => {
                if (window.FB && window.FB.ui) {
                    clearInterval(interval);

                    FBModal(url);
                }

                console.info('fb init');
            }, 100);
        }
    },

    initFBConfig: () => {
        const init = () => {
            window.FB.init({
                appId: '130723454285337',
                cookie: true,
                xfbml: true,
                version: 'v2.11'
            });

            window.FB?.AppEvents?.logPageView();
        };

        if (window.FB) {
            init();
        } else {
            window.fbAsyncInit = function () {
                init();
            };
        }
    },

    // initPinterestTracker: () => {
    //     window.dataLayer.push({
    //         event: 'initPinterestPixel',
    //         pinterestInfo: {
    //             emailHash: window.storage.getItem('emailHash')
    //         }
    //     });
    // },

    initBraze() {
        if (session.isLoggedIn()) {
            this.initBrazeSDK();
            Braze.init();
        }
    },

    initBrazeSDK: () => {
        +(function (a, p, P, b, y) {
            a.appboy = {};
            a.appboyQueue = [];
            for (
                var s =
                        'DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setAvatarImageUrl User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent display display.automaticallyShowNewInAppMessages display.destroyFeed display.hideContentCards display.showContentCards display.showFeed display.showInAppMessage display.toggleContentCards display.toggleFeed changeUser destroy getDeviceId initialize isPushBlocked isPushGranted isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession registerAppboyPushMessages removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh requestImmediateDataFlush resumeWebTracking setLogger setSdkAuthenticationSignature stopWebTracking subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToNewInAppMessages subscribeToSdkAuthenticationFailures toggleAppboyLogging trackLocation unregisterAppboyPushMessages wipeData'.split(
                            ' '
                        ),
                    i = 0;
                i < s.length;
                i++
            ) {
                for (var m = s[i], k = a.appboy, l = m.split('.'), j = 0; j < l.length - 1; j++) {
                    k = k[l[j]];
                }
                k[l[j]] = new Function(
                    `return function ${m.replace(/\./g, '_')}(){window.appboyQueue.push(arguments); return true}`
                )();
            }
            window.appboy.getCachedContentCards = function () {
                return new window.appboy.ContentCards();
            };
            window.appboy.getCachedFeed = function () {
                return new window.appboy.Feed();
            };
            window.appboy.getUser = function () {
                return new window.appboy.User();
            };
            (y = p.createElement(P)).type = 'text/javascript';
            y.src = 'https://js.appboycdn.com/web-sdk/3.4/appboy.min.js';
            y.async = 1;
            (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b);
        })(window, document, 'script');
    },

    initEhnancedEcommercePlugin: () => {
        (function () {
            var e = window,
                f = 'push',
                k = 'length',
                l = 'prototype',
                q = function (a) {
                    if (a.get && a.set) {
                        this.clear();
                        var d = a.get('buildHitTask');

                        a.set('buildHitTask', n(this, d));
                        a.set('_rlt', p(this, a.get('_rlt')));
                    }
                },
                r = {
                    action: 'pa',
                    promoAction: 'promoa',
                    id: 'ti',
                    affiliation: 'ta',
                    revenue: 'tr',
                    tax: 'tt',
                    shipping: 'ts',
                    coupon: 'tcc',
                    step: 'cos',
                    label: 'col',
                    option: 'col',
                    options: 'col',
                    list: 'pal',
                    listSource: 'pls'
                },
                t = {
                    id: 'id',
                    name: 'nm',
                    brand: 'br',
                    category: 'ca',
                    variant: 'va',
                    position: 'ps',
                    price: 'pr',
                    quantity: 'qt',
                    coupon: 'cc',
                    'dimension(\\d+)': 'cd',
                    'metric(\\d+)': 'cm'
                },
                u = { id: 'id', name: 'nm', creative: 'cr', position: 'ps' },
                v = function (a, d) {
                    this.name = a;
                    this.source = d;
                    this.e = [];
                },
                w = 'detail checkout checkout_option click add remove purchase refund'.split(' ');

            q[l].clear = function () {
                this.b = void 0;
                this.f = [];
                this.a = [];
                this.g = [];
                this.d = void 0;
            };
            q[l].h = function (a, d) {
                var b = d || {};

                a == 'promo_click' ? (b.promoAction = 'click') : (b.action = a);
                this.b = x(b);
            };
            q[l].j = function (a) {
                (a = x(a)) && this.f[f](a);
            };
            q[l].i = function (a) {
                var d = x(a);

                if (d) {
                    var b,
                        c = a.list || '';

                    a = a.listSource || '';
                    for (var g = 0; g < this.a[k]; g++) {
                        if (this.a[g].name == c) {
                            b = this.a[g];
                            break;
                        }
                    }
                    b || ((b = new v(c, a)), this.a[f](b));
                    b.e[f](d);
                }
            };
            q[l].c = function (a) {
                (a = x(a)) && this.g[f](a);
            };
            var y = function (a, d, b) {
                if (Object[l].toString.call(Object(a)) == '[object Array]') {
                    for (var c = 0; c < a[k]; c++) {
                        d.call(b, a[c]);
                    }
                }
            };

            q[l].data = function (a) {
                if (a && a.ecommerce) {
                    a = a.ecommerce;
                    a.promoView && y(a.promoView.promotions, this.c, this);
                    a.promoClick &&
                        (this.h('promo_click', a.promoClick.actionField), y(a.promoClick.promotions, this.c, this));
                    for (var d = 0; d < w[k]; d++) {
                        var b = a[w[d]];

                        if (b) {
                            this.h(w[d], b.actionField);
                            y(b.products, this.j, this);
                            break;
                        }
                    }
                    y(a.impressions, this.i, this);
                    a.currencyCode && (this.d = a.currencyCode);
                }
            };
            var n = function (a, d) {
                    return function (b) {
                        var c, g, h;

                        a.b && z(r, a.b, b, '&');
                        for (c = 0; c < a.f[k]; c++) {
                            (g = `&pr${c + 1}`), z(t, a.f[c], b, g);
                        }
                        for (c = 0; c < a.a[k]; c++) {
                            h = a.a[c];
                            g = `&il${c + 1}`;
                            h.name && b.set(`${g}nm`, h.name, !0);
                            h.source && b.set(`${g}ls`, h.source, !0);
                            for (var m = 0; m < h.e[k]; m++) {
                                z(t, h.e[m], b, `${g}pi${m + 1}`);
                            }
                        }
                        for (c = 0; c < a.g[k]; c++) {
                            (g = `&promo${c + 1}`), z(u, a.g[c], b, g);
                        }
                        a.d && b.set('&cu', a.d, !0);
                        a.clear();

                        return d(b);
                    };
                },
                p = function (a, d) {
                    return function (b) {
                        var c = a.b && a.b.action;

                        if (c != 'purchase' && c != 'refund') {
                            return d(b);
                        }
                    };
                },
                x = function (a) {
                    var d = 0,
                        b = {};

                    if (a && typeof a === 'object') {
                        for (var c in a) {
                            a.hasOwnProperty(c) && ((b[c] = a[c]), d++);
                        }
                    }

                    return d ? b : void 0;
                },
                z = function (a, d, b, c) {
                    for (var g in d) {
                        if (d.hasOwnProperty(g)) {
                            for (var h in a) {
                                if (a.hasOwnProperty(h)) {
                                    var m = g.match(`^${h}$`);

                                    m && b.set(c + a[h] + m.slice(1).join(''), d[g], !0);
                                }
                            }
                        }
                    }
                };

            (function () {
                e.gaplugins = e.gaplugins || {};
                e.gaplugins.EC = q;
                q[l].setAction = q[l].h;
                q[l].addProduct = q[l].j;
                q[l].addImpression = q[l].i;
                q[l].addPromo = q[l].c;
                q[l].clear = q[l].clear;
                q[l].data = q[l].data;
                var a = e.GoogleAnalyticsObject || 'ga';

                e[a] =
                    e[a] ||
                    function () {
                        (e[a].q = e[a].q || [])[f](arguments);
                    };
                e[a]('provide', 'ec', q);
            })();
        })();
    }
};

export default externalScriptsManager;
